/**
 * The origin of a setting.
 */
export var EcsSettingSource;
(function (EcsSettingSource) {
    EcsSettingSource["LocalStorageOverride"] = "LocalStorageOverride";
    EcsSettingSource["QueryParamOverride"] = "QueryParamOverride";
    EcsSettingSource["Default"] = "Default";
    EcsSettingSource["CachedServiceResponse"] = "CachedServiceResponse";
})(EcsSettingSource || (EcsSettingSource = {}));
//# sourceMappingURL=ecsClientInterfaces.js.map